/**
 * RT 再表示チェーンの表示順・上限まわりの純ロジック。
 * チェーン状態機械（factory）は composables/useRtPopupRepeatChain.ts に残す。
 */

/** RT 再表示チェーンで特定 KW 該当時に上限を 4 件にするキーワード */
const RT_REPEAT_KEYWORDS = [
  '施工管理',
  '自動車整備士',
  '電気主任技術者',
  '薬剤師',
  '介護士',
  '看護師'
]

/** 通常時の合計表示上限（初回 + 追加1）— MyPage 等のレガシー経路用 */
const RT_TOTAL_DISPLAY_MAX_DEFAULT = 2

/** 特定 KW 該当時の合計表示上限（初回 + 追加3）— MyPage 等のレガシー経路用 */
const RT_TOTAL_DISPLAY_MAX_KW = 2

export const RT_SUB_ACCEPT_LABEL_AFTER_SEND = '他の仕事紹介も希望する'

/** RT連続表示チェーン内で現在表示しているダイアログの1始まりの表示順 */
export function getRtDisplayCountNum(countRepeat: number): number {
  return 1 + countRepeat
}

/** display_dialog 用: アクティブなチェーンの表示順（モジュール級。Vue instance data には載せない） */
let activeDisplayCountNum = 1

export function getActiveRtDisplayCountNum(): number {
  return activeDisplayCountNum
}

/**
 * FormatEdit プレイリスト順など、1始まりの表示順を直接セットする。
 * （チェーン内 countRepeat 由来の更新とは別経路）
 */
export function setActiveRtDisplayCountNumValue(n: number) {
  activeDisplayCountNum = Math.max(1, n | 0)
}

export type GlobalVarRepeat = {
  checkRepeatRTChainExtendedKeywords: (
    formatId: string,
    formatData: object | null | undefined,
    keywordlist: string[],
    shokumuFromOther?: object | null
  ) => boolean
}

export function getRtRepeatTotalDisplayMax(
  globalVar: GlobalVarRepeat,
  formatId: string,
  formatData: object | null | undefined,
  shokumuFromOther?: object | null
): number {
  const hasRepeatKW = globalVar.checkRepeatRTChainExtendedKeywords(
    formatId,
    formatData,
    RT_REPEAT_KEYWORDS,
    shokumuFromOther
  )
  return hasRepeatKW ? RT_TOTAL_DISPLAY_MAX_KW : RT_TOTAL_DISPLAY_MAX_DEFAULT
}

export function restoreRtConditionAfterRepeatEnd<T extends object>(
  disableRtCondition4Repeat: T | null | undefined,
  applyPending: (conditionSet: T) => T
): T | undefined {
  if (!disableRtCondition4Repeat) return undefined
  const restored = JSON.parse(JSON.stringify(disableRtCondition4Repeat)) as T
  return applyPending(restored)
}
